import { styled } from "@monolith-forensics/monolith-ui";

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  min-width: 150px;

  border-right: 1px solid ${({ theme }) => theme.palette.action.hover};
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-x: hidden;

  padding: 0px 10px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.palette.text.secondary};

  .tab {
    padding: 5px 15px 5px 10px;
    border-left: 3px solid transparent;
  }

  .tab:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }

  a.active .tab {
    border-left-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
